module.exports = __webpack_public_path__ + "static/img/gbz-965-385bb.2a840e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gbz-965-385bb.jpg
// module id = uCdo
// module chunks = 0